import {logger} from '@/utils/logger';
import {BabybookService, BABYBOOK_LOOKUP_RESULT} from '@/services/babybook';
import {
  GETTER_BABYBOOK_WHITELIST,
  ACTION_FETCH_BABYBOOK_WHITELIST,
  ACTION_CLEAR_BABYBOOK_MODULE,
  MUTATE_BABYBOOK_WHITELIST,
  MUTATE_BABYBOOK_FETCHING,
  MUTATE_CLEAR_BABYBOOK_MODULE,
} from './types';

let latestRequestId = 0;

const getDefaultState = () => ({
  whitelistedTokens: null,
  isFetching: false,
});

const state = getDefaultState();

const getters = {
  [GETTER_BABYBOOK_WHITELIST]: ({whitelistedTokens}) => whitelistedTokens,
};

const actions = {
  [ACTION_FETCH_BABYBOOK_WHITELIST]: async ({state, commit}, {force = false} = {}) => {
    if (!force && (state.whitelistedTokens !== null || state.isFetching)) return;

    const requestId = ++latestRequestId;
    commit(MUTATE_BABYBOOK_FETCHING, true);
    try {
      const {data} = await BabybookService.getWhitelistedTokens();
      if (requestId !== latestRequestId) return;
      if (data && data.result === BABYBOOK_LOOKUP_RESULT.SUCCESS && Array.isArray(data.data)) {
        commit(MUTATE_BABYBOOK_WHITELIST, data.data);
      } else {
        commit(MUTATE_BABYBOOK_WHITELIST, []);
      }
    } catch (error) {
      if (requestId !== latestRequestId) return;
      logger.error('babybook eligibility lookup failed', {message: error.message});
      commit(MUTATE_BABYBOOK_WHITELIST, []);
    } finally {
      if (requestId === latestRequestId) {
        commit(MUTATE_BABYBOOK_FETCHING, false);
      }
    }
  },
  [ACTION_CLEAR_BABYBOOK_MODULE]: ({commit}) => {
    latestRequestId++;
    commit(MUTATE_CLEAR_BABYBOOK_MODULE);
  },
};

const mutations = {
  [MUTATE_BABYBOOK_WHITELIST]: (state, tokens) => {
    state.whitelistedTokens = tokens;
  },
  [MUTATE_BABYBOOK_FETCHING]: (state, isFetching) => {
    state.isFetching = isFetching;
  },
  [MUTATE_CLEAR_BABYBOOK_MODULE]: (state) => {
    Object.assign(state, getDefaultState());
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};